<template>
    <div class="content">
        <div class="title"></div>
        <div class="text">
            <p v-for="(items,index) in textList" :key="index">
                {{items}}
            </p>

        </div>

    </div>

</template>

<script>
    export default {
        name: "Contact",
        data() {
            return {
                textList: [
                    '北京红松在线科技有限公司',
                    '北京市朝阳区融科望京中心A座',
                    ' jobs@hongsong.com'
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    .content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .title {
            width: 100%;
            height: 36.5px;
            margin-bottom: 22.5px;
            background: url("../assets/img/contact-us.png") center/contain no-repeat;
        }

        .text {
            line-height: 32px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            letter-spacing: 1px;

        }
    }

</style>